/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { useQuery, useMutation } from '@apollo/client';

import { Box } from '@mui/material';
import { toast } from 'react-toastify';

import * as Q from '../../../../../constants/graphqlQueries';

import './AccessDetails.css'
import 'react-toastify/dist/ReactToastify.css';
import CustomTextField from '../../../../components/Textfield/CustomTextField';
import ControlledTreview from '../../../../components/Treeview/ControlledTreeview'
import { chunkArrayInGroups, getDictionaryFromArray, getDictionaryFromArrayAsync } from '../../../../../utils/arrays';
import transactionResponse from '../../../../../constants/transactionResponse';


const CPPSTitle = 'Client Selection';
const transactionMessages = { moduleName: 'Client access' }


const AccessDetails = ({ rowData }) => {
  const toastId = useRef();
  const { data: dataClients } = useQuery(Q.APP_ALERT_CLIENTS_ALIAS_GL_QUERY);
  const { data: dataParentOrganizations, loading: dataParentOrganizationsIsLoading } = useQuery(Q.APP_ALERT_PARENT_ORGANIZATIONS_FORMATTED_GL_QUERY);
  const { data: dataClientParentAccess, refetch: refetchClientParentAccess, loading: dataClientParentAccessIsLoading } = useQuery(Q.ADMIN_MANAGMENT_SEARCH_CLIENT_PARENT_ACCESS, { variables: { EmployeeId: rowData.rowData.EmployeeId } });
  const [addClientParentAccess, { data: dataAddClientParentAccess, loading: addAccessIsLoading }] = useMutation(Q.ADMIN_MANAGMENT_CREATE_CLIENT_PARENT_ACCESS);
  const [removeClientParentAccess, { data: dataRemoveClientParentAccess, loading: removeAccessIsLoading }] = useMutation(Q.ADMIN_MANAGMENT_DELETE_CLEINT_PARENT_ACCESS);

  const [search, setSearch] = useState({
    selectedClients: '',
    searchClients: '',
    timerSelectedClients: {},
    timerSearchClients: {},
    searchClientsFilterTerm: '',
    selectedClientsFilterTerm: ''
  });

  const [parentWithChildrenInput, setParentWithChildrenInput] = useState({
    searchClients: [],
    selectedClients: []
  });

  const [searchClientsOnMount, setSearchClientsOnMount] = useState(true);
  const [selectedClientsOnMount, setSelectedClientsOnMount] = useState(true);

  const [parentsClientsIndexed, setParentsClientsIndexed] = useState({ Parents: {}, Clients: {} });
  const [parentClientState, setParentClientState] = useState({
    searchClientsParentsWithChildrenInput: [],
    mappedParentsWithChildrenInput: [],
    clientsToRemove: [],
    selectedClientsForMappedTreeview: []
  });

  // On mount, getParentOrganizations gets executed
  useEffect(() => {
    if (dataClients) {
      if (dataClients.getClients) {
        const groupsOfClients = chunkArrayInGroups(dataClients.getClients, 100);
        const indexedClientsList = [];
        groupsOfClients.map(group => indexedClientsList.push(getDictionaryFromArrayAsync(group, 'ChildrenId')));
        let clientsIndexed = {};
        Promise.all(indexedClientsList).then(groupsIndexed => {
          groupsIndexed.map(groupIndexed => {
            clientsIndexed = { ...clientsIndexed, ...groupIndexed }
            return null;
          });

          setParentsClientsIndexed({ ...parentsClientsIndexed, Clients: clientsIndexed });
        });
      }
    }
  }, [dataClients]);
  // On mount, getParentOrganizations gets executed
  useEffect(() => {
    if (dataParentOrganizations) {
      if (dataParentOrganizations.getParentOrganizations) {
        const parentsByKey = getDictionaryFromArray(dataParentOrganizations.getParentOrganizations, 'ParentId');

        setParentsClientsIndexed({
          ...parentsClientsIndexed, Parents: parentsByKey
        });
      }
    }
  }, [dataParentOrganizations]);

  // If response from adding Client Parent access
  useEffect(() => {
    if (dataAddClientParentAccess) {
      if (dataAddClientParentAccess.createWFMClientParentAccess) {
        if (dataAddClientParentAccess.createWFMClientParentAccess.duplicated === 0) {
          toast.dismiss(toastId.current);
          toastId.current = toast(transactionResponse(transactionMessages.moduleName, dataAddClientParentAccess.createWFMClientParentAccess.status));
        }
        else {
          toast.dismiss(toastId.current);
          toastId.current = toast(dataAddClientParentAccess.createWFMClientParentAccess.status);
        }
      }

    }
  }, [dataAddClientParentAccess]);

  // If response from removing Client Parent access
  useEffect(() => {
    if (dataRemoveClientParentAccess) {
      if (dataRemoveClientParentAccess.deleteWFMClientParentAccess) {
        toast.dismiss(toastId.current);
        toastId.current = toast(transactionResponse(transactionMessages.moduleName, dataRemoveClientParentAccess.deleteWFMClientParentAccess.status));

        const parentsOnMapped = parentClientState.mappedParentsWithChildrenInput.map(item => ({ ...item }));
        const parentIds = parentsOnMapped.map(parent => parent.ParentId);
        const childrenIds = [];

        parentsOnMapped.map((parent) => parent.children.map(child => childrenIds.push(child.ChildrenId)));
        refetchClientParentAccess();

        setParentClientState({ ...parentClientState, selectedClientsForMappedTreeview: [...parentIds, ...childrenIds], clientsToRemove: [] });
      }
    }
  }, [dataRemoveClientParentAccess]);

  // If employee has mapped access already, fill the state with the data
  useEffect(() => {
    if (dataClientParentAccess) {
      if (dataClientParentAccess.getWFMClientParentAccess && Object.keys(parentsClientsIndexed.Clients).length && Object.keys(parentsClientsIndexed.Parents).length) {
        const clients = [];

        dataClientParentAccess.getWFMClientParentAccess.map((access) => clients.push({ ...parentsClientsIndexed.Clients[access.ClientCode] }));

        const clientIdsSelected = clients.map(item => item.ChildrenId);
        const idsSelected = [...clientIdsSelected, ... [...new Set(clients.map(item => item.ParentId))]];
        const parentsSelectedRemovedDuplicatesIds = [...new Set(clients.map(item => item.ParentId))];
        const parentsSelectedRemovedDuplicates = parentsSelectedRemovedDuplicatesIds.map(parentId => parentsClientsIndexed.Parents[parentId]);
        const parentsSelectedId = parentsSelectedRemovedDuplicates.map((parent) => {
          const parentUpdated = { ...parent }
          parentUpdated.children = parent.children.filter(child => clientIdsSelected.includes(child.ChildrenId));

          return parentUpdated;
        });

        let replaceInputSelection = dataParentOrganizations.getParentOrganizations.map(parent => ({ ...parent }));
        replaceInputSelection = replaceInputSelection.map((parent) => {
          const parentUpdated = { ...parent }
          parentUpdated.children = parent.children.filter(child => !(clientIdsSelected.includes(child.ChildrenId)));

          return parentUpdated;
        }).filter(parent => parent.children.length > 0);

        setParentClientState({ ...parentClientState, mappedParentsWithChildrenInput: parentsSelectedId, selectedClientsForMappedTreeview: idsSelected, searchClientsParentsWithChildrenInput: replaceInputSelection });
      }
    }
  }, [dataClientParentAccess, parentsClientsIndexed]);

  // If changes in the source input, apply to treeview data
  useEffect(() => {  
    if (parentClientState.mappedParentsWithChildrenInput || parentClientState.searchClientsParentsWithChildrenInput) {
      const updatedMapped = parentClientState.mappedParentsWithChildrenInput;
      const updatedSearchClients = parentClientState.searchClientsParentsWithChildrenInput;

      setParentWithChildrenInput({ ...parentWithChildrenInput, selectedClients: updatedMapped, searchClients: updatedSearchClients });
    }
  }, [parentClientState.mappedParentsWithChildrenInput, parentClientState.searchClientsParentsWithChildrenInput]);

  // If search, apply filter to treeview data
  useEffect(() => {
    const timer = setTimeout(() => {
      if (search.searchClients.trim() !== '') {
        const filteredSearchClients = parentWithChildrenInput.searchClients.filter((parent) => {
          let result = parent.ParentLabel.toLowerCase().startsWith(search.searchClients);
  
          if (!result) {
            parent.children.map((child) => {
              if (child.ChildrenLabel.toLowerCase().startsWith(search.searchClients)) {
                result = true;
              }

              return null;
            });
          }
  
          return result;
        });
  
        setParentWithChildrenInput({ ...parentWithChildrenInput, searchClients: filteredSearchClients });
      }
      else {
        setParentWithChildrenInput({ ...parentWithChildrenInput, searchClients: parentClientState.searchClientsParentsWithChildrenInput });
      }
    }, 500);

    setSearch({ ...search, timerSearchClients: timer });
  }, [search.searchClientsFilterTerm]);

  useEffect(() => {
    if (parentWithChildrenInput.searchClients.length) {
      return setSearchClientsOnMount(false);
    }

    return setSelectedClientsOnMount(true);
  }, [parentWithChildrenInput.searchClients]);

  useEffect(() => {
    if (parentWithChildrenInput.selectedClients.length || parentWithChildrenInput.selectedClients !== undefined) {
      return setSelectedClientsOnMount(false);
    }

    return setSelectedClientsOnMount(true);
  }, [parentWithChildrenInput.selectedClients]);

  // If search, apply filter to treeview data
  useEffect(() => {
    const timer = setTimeout(() => {
      if (search.selectedClients.trim() !== '') {
        const filteredSearchClients = parentWithChildrenInput.selectedClients.filter((parent) => {
          let result = parent.ParentLabel.toLowerCase().startsWith(search.selectedClients);
  
          if (!result) {
            parent.children.map((child) => {
              if (child.ChildrenLabel.toLowerCase().startsWith(search.selectedClients)) {
                result = true;
              }

              return null;
            });
          }
  
          return result;
        });
  
        setParentWithChildrenInput({ ...parentWithChildrenInput, selectedClients: filteredSearchClients });
      }
      else {
        setParentWithChildrenInput({ ...parentWithChildrenInput, selectedClients: parentClientState.mappedParentsWithChildrenInput });
      }
    }, 500);

    setSearch({ ...search, timerSelectedClients: timer });
  }, [search.selectedClientsFilterTerm]);

  useEffect(() => {
    clearTimeout(search.timerSearchClients);
    setSearch({ ...search, searchClientsFilterTerm: search.searchClients });
  }, [search.searchClients]);

  useEffect(() => {
    clearTimeout(search.timerSelectedClients);
    setSearch({ ...search, selectedClientsFilterTerm: search.selectedClients });
  }, [search.selectedClients]);

  const getUpdatedStateOnParentSelection = (parentClientId) => {
    const selectedParent = { ...parentsClientsIndexed.Parents[parentClientId] }
    const filteredInput = parentClientState.searchClientsParentsWithChildrenInput.filter(parent => parent.ParentId !== parentClientId);
    const clients = selectedParent.children.map((child) => child.ChildrenId);
    const parentClientsIds = [...clients, parentClientId];

    const replacementParentChildrenInput = filteredInput;
    let replacementPreviewMappedParentsClients = [selectedParent];

    if ('mappedParentsWithChildrenInput' in parentClientState) {
      if (!(parentClientState.mappedParentsWithChildrenInput.filter(item => item.ParentId === parentClientId).length)) {
        replacementPreviewMappedParentsClients = [...parentClientState.mappedParentsWithChildrenInput, selectedParent];
      }
      else {
        const indexForParent = parentClientState.mappedParentsWithChildrenInput.findIndex(item => item.ParentId === parentClientId);
        replacementPreviewMappedParentsClients = parentClientState.mappedParentsWithChildrenInput.map(item => item);
        const parentInput = { ...parentClientState.searchClientsParentsWithChildrenInput.find(parent => parent.ParentId === parentClientId) }
        parentInput.children.map(item => replacementPreviewMappedParentsClients[indexForParent].children.push(item));
      }
    }

    const replacementeSelectedClientsForPreview = [...new Set([...parentClientState.selectedClientsForMappedTreeview, ...parentClientsIds])];

    return {
      searchClientsParentsWithChildrenInput: replacementParentChildrenInput,
      mappedParentsWithChildrenInput: replacementPreviewMappedParentsClients,
      selectedClientsForMappedTreeview: replacementeSelectedClientsForPreview
    }
  }

  const getUpdatedStateOnClientSelection = (parentClientId) => {
    const client = { ...parentsClientsIndexed.Clients[parentClientId] }
    const originalParent = { ...parentsClientsIndexed.Parents[client.ParentId] }
    let parentsFromInput = parentClientState.searchClientsParentsWithChildrenInput.map(item => item);
    const selectedParentInInput = { ...parentsFromInput.find(parentInput => parentInput.ParentId === originalParent.ParentId) }

    if (selectedParentInInput.children.length > 1) {
      const indexParent = parentsFromInput.findIndex(item => item.ParentId === originalParent.ParentId);

      originalParent.children = [parentsFromInput[indexParent].children.find(childrenInput => childrenInput.ChildrenId === parentClientId)];
      const childrenNodeToReplace = parentsFromInput[indexParent].children.filter(childrenInput => childrenInput.ChildrenId !== parentClientId);
      parentsFromInput[indexParent].children = childrenNodeToReplace;
    }
    else if (selectedParentInInput.children.length === 1) {
      parentsFromInput = parentsFromInput.filter(parentInput => parentInput.ParentId !== originalParent.ParentId);
    }

    const replacementParentChildrenInput = parentsFromInput;
    let replacementPreviewMappedParentsClients = null;

    if ('mappedParentsWithChildrenInput' in parentClientState) {
      if (!(parentClientState.mappedParentsWithChildrenInput.filter(item => item.ParentId === originalParent.ParentId).length)) {
        replacementPreviewMappedParentsClients = [...parentClientState.mappedParentsWithChildrenInput, originalParent];
      }
      else {
        const indexForParent = parentClientState.mappedParentsWithChildrenInput.findIndex(item => item.ParentId === originalParent.ParentId);
        replacementPreviewMappedParentsClients = parentClientState.mappedParentsWithChildrenInput.map(item => item);
        replacementPreviewMappedParentsClients[indexForParent].children.push(client);
      }
    }
    else {
      replacementPreviewMappedParentsClients = [originalParent];
    }

    let replacementeSelectedClientsForPreview = parentClientState.selectedClientsForMappedTreeview;

    if ('selectedClientsForMappedTreeview' in parentClientState) {
      if (!(parentClientState.selectedClientsForMappedTreeview.includes(parentClientId))) {
        if (!(parentClientState.selectedClientsForMappedTreeview.includes(originalParent.ParentId))) {
          const parentWithClientIds = [parentClientId, originalParent.ParentId];

          replacementeSelectedClientsForPreview = [...parentClientState.selectedClientsForMappedTreeview, ...parentWithClientIds];
        }
        else {
          replacementeSelectedClientsForPreview = [...parentClientState.selectedClientsForMappedTreeview, parentClientId];
        }
      }
      else if (!(parentClientState.selectedClientsForMappedTreeview.includes(originalParent.ParentId))) {
        replacementeSelectedClientsForPreview = [...parentClientState.selectedClientsForMappedTreeview, originalParent.ParentId];
      }
    }
    else {
      const parentWithClientIds = [parentClientId, originalParent.ParentId];

      replacementeSelectedClientsForPreview = parentWithClientIds;
    }
    
    return {
      searchClientsParentsWithChildrenInput: replacementParentChildrenInput,
      mappedParentsWithChildrenInput: replacementPreviewMappedParentsClients,
      selectedClientsForMappedTreeview: replacementeSelectedClientsForPreview
    }
  }

  const getUpdatedStateOnParentRemoval = (parentOrClientId) => {
    const clients =  { ...parentsClientsIndexed.Parents[parentOrClientId] }.children.map((child) => child.ChildrenId);
    const parentClient = { ...parentClientState.mappedParentsWithChildrenInput.find(parentPreview => parentPreview.ParentId === parentOrClientId) }
    let parentChildrenInputSorted = parentClientState.searchClientsParentsWithChildrenInput.map(item => item);

    if (!(parentChildrenInputSorted.filter(item => item.ParentId === parentClient.ParentId).length)) {
      parentChildrenInputSorted.push(parentClient);
    }
    else {
      const indexForParent = parentChildrenInputSorted.findIndex(item => item.ParentId === parentClient.ParentId);
      parentClient.children.map(item => parentChildrenInputSorted[indexForParent].children.push(item));
    }

    parentChildrenInputSorted = parentChildrenInputSorted.sort((a, b) => a.ParentLabel.localeCompare(b.ParentLabel, 'en', { numeric: true }));
    const filteredClientsPreview = [...parentClientState.selectedClientsForMappedTreeview].filter(id => id !== parentOrClientId);
    const filteredSelectedClients = [...clients];

    const replacementParentChildrenInput = parentChildrenInputSorted;
    const replacementPreviewMappedParentsClients = parentClientState.mappedParentsWithChildrenInput.filter(parentPreview => parentPreview.ParentId !== parentOrClientId);
    const replacementSelectedClients = filteredSelectedClients;
    const replacementeSelectedClientsForPreview = filteredClientsPreview;

    return {
      searchClientsParentsWithChildrenInput: replacementParentChildrenInput,
      mappedParentsWithChildrenInput: replacementPreviewMappedParentsClients,
      clientsToRemove: replacementSelectedClients,
      selectedClientsForMappedTreeview: replacementeSelectedClientsForPreview
    }
  }

  const getUpdatedStateOnClientRemoval = (parentOrClientId) => {
    const updatedParentsChildrenInput = parentClientState.searchClientsParentsWithChildrenInput.map(item => item);
    const client = { ...parentsClientsIndexed.Clients[parentOrClientId] }
    const originalParent = { ...parentsClientsIndexed.Parents[client.ParentId] }
    const parentFromMappedClient = { ...parentClientState.mappedParentsWithChildrenInput.find(parentPreview => parentPreview.ParentId === originalParent.ParentId) }

    let previewInput = parentClientState.mappedParentsWithChildrenInput.map(item => item);
    let selectedForPreviewInput = parentClientState.selectedClientsForMappedTreeview.map(item => item);
    let childrenNodeToReplace = [];

    if (parentFromMappedClient.children.length > 1) {
      let parentIndex = 0;

      if (!(updatedParentsChildrenInput.filter(parentInput => parentInput.ParentId === originalParent.ParentId).length)) {
        updatedParentsChildrenInput.push(parentFromMappedClient);
        parentIndex = updatedParentsChildrenInput.findIndex(parentChildren => parentChildren.ParentId === originalParent.ParentId);

        childrenNodeToReplace = updatedParentsChildrenInput[parentIndex].children.filter(childrenInput => childrenInput.ChildrenId === parentOrClientId);
      }
      else {
        parentIndex = updatedParentsChildrenInput.findIndex(parentChildren => parentChildren.ParentId === originalParent.ParentId);
        
        childrenNodeToReplace = updatedParentsChildrenInput[parentIndex].children;
        childrenNodeToReplace.push(client);
      }

      selectedForPreviewInput = selectedForPreviewInput.filter(clientSelectedPreview => clientSelectedPreview !== parentOrClientId);
      updatedParentsChildrenInput[parentIndex].children = childrenNodeToReplace;
      const indexOnPreview = previewInput.findIndex(previewParentInput => previewParentInput.ParentId === originalParent.ParentId);
      previewInput[indexOnPreview].children = parentFromMappedClient.children.filter(child => child.ChildrenId !== parentOrClientId);
    }
    else {
      if (!(updatedParentsChildrenInput.filter(parentInput => parentInput.ParentId === originalParent.ParentId).length)) {
        updatedParentsChildrenInput.push(parentFromMappedClient);
      }
      else {
        const parentIndex = updatedParentsChildrenInput.findIndex(parentChildrenInput => parentChildrenInput.ParentId === originalParent.ParentId);
        updatedParentsChildrenInput[parentIndex].children.push(client);
      }

      previewInput = previewInput.filter(parentInput => parentInput.ParentId !== originalParent.ParentId);
      selectedForPreviewInput = selectedForPreviewInput.filter(clientSelectedPreview => clientSelectedPreview !== parentOrClientId && clientSelectedPreview !== originalParent.ParentId);
    }

    updatedParentsChildrenInput.sort((a, b) => a.ParentLabel.localeCompare(b.ParentLabel, 'en', { numeric: true }));
      
    return {
      searchClientsParentsWithChildrenInput: updatedParentsChildrenInput,
      mappedParentsWithChildrenInput: previewInput,
      selectedClientsForMappedTreeview: selectedForPreviewInput,
      clientsToRemove: [...parentClientState.clientsToRemove, parentOrClientId]
    }
  }

  /**
   * Handlers
   */
  const handleSearchClientsSearch = (searchInput) => {
    clearTimeout(search.timerSearchClients);
    return setSearch({ ...search, searchClients: searchInput.toLowerCase()});
  }

  const handleMappedSearch = (searchInput) => {
    clearTimeout(search.timerSelectedClients);
    return setSearch({ ...search, selectedClients: searchInput.toLowerCase()});
  }

  const handleSelect = (event, nodeIds) => {
    if (event.target.nodeName === 'svg') {
        return;
    }

    const parentClientId = nodeIds[0];
    // Validate if id is for Parent or Client Entity
    if (parentClientId in parentsClientsIndexed.Parents) {
      const updatedState = getUpdatedStateOnParentSelection(parentClientId);
      const clientIds = updatedState.selectedClientsForMappedTreeview.filter(item => !(item in parentsClientsIndexed.Parents));

      addClientParentAccess({
        variables: {
          input: {
            EmployeeId: rowData.rowData.EmployeeId,
            ClientsSelected: clientIds.map(
              (client) => ({
                ClientCode: client,
              }),
            ),
          },
        },
      });

      setParentClientState({
        ...parentClientState,
        ...updatedState
      });
    }
    else {
      const updatedState = getUpdatedStateOnClientSelection(parentClientId);
      const clientIds = updatedState.selectedClientsForMappedTreeview.filter(item => !(item in parentsClientsIndexed.Parents));
      addClientParentAccess({
        variables: {
          input: {
            EmployeeId: rowData.rowData.EmployeeId,
            ClientsSelected: clientIds.map(
              (client) => ({
                ClientCode: client,
              }),
            ),
          },
        },
      });

      setParentClientState({
        ...parentClientState,
        ...updatedState
      });
    }
  }
  
  const handleRemove = (event, nodeIds) => {
    if (event.target.nodeName === 'svg') {
        return;
    }

    const parentOrClientId = nodeIds[0];
    if (parentClientState.selectedClientsForMappedTreeview.includes(parentOrClientId)) {
      if (parentOrClientId in parentsClientsIndexed.Parents) {
        const updatedState = getUpdatedStateOnParentRemoval(parentOrClientId);
        const clientIds = updatedState.clientsToRemove.filter(item => !(item in parentsClientsIndexed.Parents));

        removeClientParentAccess({
          variables: {
            input: {
              EmployeeId: rowData.rowData.EmployeeId,
              ClientsSelected: clientIds.map(
                (client) => ({
                  ClientCode: client,
                }),
              ),
            },
          },
        });
        setParentClientState({ ...parentClientState, ...updatedState })
      }
      else {
        const updatedState = getUpdatedStateOnClientRemoval(parentOrClientId);
        const clientIds = updatedState.clientsToRemove.filter(item => !(item in parentsClientsIndexed.Parents));

        removeClientParentAccess({
          variables: {
            input: {
              EmployeeId: rowData.rowData.EmployeeId,
              ClientsSelected: clientIds.map(
                (client) => ({
                  ClientCode: client,
                }),
              ),
            },
          },
        });

        setParentClientState({ ...parentClientState, ...updatedState })
      }
    }
  }

  return (
    <Box className='admin__details__wrapper'>
      <p className='admin__details__title'>
        {CPPSTitle}
      </p>
      <Box className='admin__details__box__wrapper'>
        <Box className='admin__details__box search-clients'>
          <CustomTextField
            width='390px'
            title='Client Search'
            value={search.searchClients}
            handleChange={handleSearchClientsSearch}
            placeholder='Search'
            mandatory
            inputIcon
          />
          <Box className='client-search-treeview-box'>
            <ControlledTreview
              isLoading={addAccessIsLoading || removeAccessIsLoading || dataParentOrganizationsIsLoading || dataClientParentAccessIsLoading || searchClientsOnMount || false}
              item={parentWithChildrenInput.searchClients}
              selectedItems={[]}
              handleSelection={handleSelect}
              allExpanded
            />
          </Box>
        </Box>
        <Box className='admin__details__box selected'>
          <CustomTextField
            width='390px'
            title='Selected Clients'
            value={search.selectedClients}
            handleChange={handleMappedSearch}
            placeholder='Search'
            mandatory
            inputIcon
          />
          <Box className='selected-clients-treeview-box'>
            <ControlledTreview
              isLoading={addAccessIsLoading || removeAccessIsLoading || dataClientParentAccessIsLoading || selectedClientsOnMount || searchClientsOnMount || false}
              item={parentWithChildrenInput.selectedClients}
              selectedItems={parentClientState.selectedClientsForMappedTreeview || []}
              handleSelection={handleRemove}
              allExpanded
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

AccessDetails.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rowData: PropTypes.object.isRequired,
}

export default AccessDetails
